import React, { useState } from 'react';
import {
  Box, Container, Typography, Accordion, AccordionSummary, AccordionDetails,
} from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { C, Section, SectionLabel } from './theme';

const faqs = [
  {
    q: 'What is VPS hosting?',
    a: 'VPS hosting (Virtual Private Server hosting) gives you your own virtual server — an isolated virtual machine on a physical server — so you get dedicated resources, stronger security/isolation, and full control of your server environment. Thanks to virtualization, multiple VPS servers run on the same hardware, but each has its own operating system, disk space, and server configurations. You can install custom software and optimize for your specific workloads.',
  },
  {
    q: 'What does a VPS hosting plan include?',
    a: 'With a VPS hosting plan, you get dedicated resources (vCPU, RAM, NVMe SSD storage) for exceptional performance and stability under high traffic, full root access and server management freedom, advanced security options (firewalling, DDoS protection integrations) plus backups, and easy scalability to add more resources with just a few clicks.',
  },
  {
    q: 'What is NVMe SSD storage?',
    a: 'NVMe (Non-Volatile Memory Express) is the protocol that lets NVMe SSD drives deliver far higher data transfer speeds and lower latency than SATA SSDs — translating to faster performance and page loads for hosting websites and apps. With NVMe SSD storage, busy sites and popular software stacks feel snappier, even under peak traffic.',
  },
  {
    q: 'When should I use VPS hosting?',
    a: 'Use a VPS solution when you need power, control, and flexibility: high-traffic sites, ecommerce, agency hosting, custom stacks (LAMP/LEMP, queues, search) on Linux operating systems, staging/dev environments, APIs, SaaS apps — anything that benefits from full root access, unmetered bandwidth, and custom tuning.',
  },
  {
    q: 'Which operating systems can I run on a VPS?',
    a: 'VPS hosting provides flexibility to run various operating systems, with robust support for popular Linux distributions like AlmaLinux 9, Ubuntu, CentOS, Debian, and Fedora. You have full root access to configure your ideal server environment.',
  },
  {
    q: 'What type of support comes with VPS hosting?',
    a: 'Our managed VPS hosting comes with 24/7 support from certified experts. For self-managed plans, you get root access and tools to configure your server independently, with optional support add-ons available for server management and troubleshooting.',
  },
  {
    q: 'Can I scale my VPS resources as my site grows?',
    a: 'Yes, you can scale CPU, RAM, and disk space with just a few clicks inside your control panel. Upgrading keeps your server, IPs, and data intact, so your site stays fast and responsive without re-architecting.',
  },
  {
    q: 'How much does VPS hosting cost?',
    a: 'Hosting Services VPS hosting starts at ₹198/month and ranges up to ₹9,471/month depending on the plan and support needs. You can start with a smaller configuration and seamlessly scale up over time.',
  },
];

const VpsFaq = () => {
  const [expanded, setExpanded] = useState(0);

  return (
    <Section id="faq" sx={{ background: C.bgSection, borderBottom: `1px solid ${C.border}` }}>
      <Container maxWidth="lg">

        {/* Section Header */}
        <Box sx={{ textAlign: 'center', mb: 6 }}>
          <SectionLabel>FAQ</SectionLabel>
          <Typography variant="h2" sx={{
            fontWeight: 800, fontSize: { xs: '1.85rem', md: '2.5rem' },
            color: C.textPrimary, letterSpacing: '-0.03em', mb: 1.5,
          }}>
            VPS Hosting FAQs
          </Typography>
          <Typography sx={{ color: C.textSecondary, fontSize: '1rem', maxWidth: 600, mx: 'auto' }}>
            Got questions about virtual private servers? Here are clear answers to help you choose.
          </Typography>
        </Box>

        {/* Accordions */}
        <Box sx={{ maxWidth: 880, mx: 'auto' }}>
          {faqs.map((faq, i) => (
            <Accordion key={i} expanded={expanded === i} onChange={() => setExpanded(expanded === i ? false : i)}
              elevation={0}
              sx={{
                background: '#FFFFFF',
                border: `1px solid ${expanded === i ? C.primary : C.border}`,
                borderRadius: '12px !important',
                mb: 1.5,
                '&:before': { display: 'none' },
                boxShadow: expanded === i ? '0 4px 12px rgba(37,99,235,0.08)' : 'none',
                transition: 'all 0.18s',
              }}>
              <AccordionSummary expandIcon={<ExpandMore sx={{ color: C.primary }} />} sx={{ px: 3, py: 1 }}>
                <Typography sx={{ color: C.textPrimary, fontWeight: 700, fontSize: '0.98rem' }}>
                  {faq.q}
                </Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ px: 3, pb: 3, pt: 0 }}>
                <Typography sx={{ color: C.textSecondary, fontSize: '0.9rem', lineHeight: 1.7 }}>
                  {faq.a}
                </Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </Box>

      </Container>
    </Section>
  );
};

export default VpsFaq;
